/* Le Garage : écran de sélection de pilote (wipe diagonal, textes en
   machine à sous, mutation d'ambiance par pilote via --accent).
   Les données viennent du JSON #gg-data rendu par Liquid depuis les
   métaobjets pilote (tri par champ ordre, numéros recalculés ici).
   Navigation clic/flèches/clavier/molette/swipe, deep link par hash,
   prefers-reduced-motion respecté, verrou anti-spam. */
(function () {
  'use strict';
  const dataEl = document.getElementById('gg-data');
  if (!dataEl) return;
  const DATA = JSON.parse(dataEl.textContent);
  const T = DATA.t;
  const img = (p) => p.img_url || DATA.assetBase + p.img_demo;

  const PILOTES = DATA.pilotes.slice().sort((a, b) => a.ordre - b.ordre);
  /* numéro de course du métaobjet (champ numero) ; à défaut, recalcul
     01..n sur l'ordre du roster */
  PILOTES.forEach((p, i) => { p.num = p.numero || String(i + 1).padStart(2, '0'); });

  const STATS_NOMS = T.stats;
  const SVG_INSTA = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r="1" fill="currentColor" stroke="none"/></svg>';
  const SVG_TIKTOK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4v10.8a3.9 3.9 0 1 1-3.9-3.9"/><path d="M14.5 5.2c.6 2.3 2.2 3.8 4.7 4.1"/></svg>';

  const $ = (id) => document.getElementById(id);
  const sec = $('garage');
  const rm = matchMedia('(prefers-reduced-motion: reduce)');
  const EXPO = 'cubic-bezier(.19,1,.22,1)', HARD = 'cubic-bezier(.77,0,.18,1)';
  let idx = 0, verrou = false, derniereMolette = 0;

  /* préchargement des photos pour un wipe sans trou */
  PILOTES.forEach((p) => { const i = new Image(); i.src = img(p); });

  /* ---------- construction du roster ---------- */
  PILOTES.forEach((p, i) => {
    const b = document.createElement('button');
    b.className = 'gg-vig'; b.style.setProperty('--vc', p.accent);
    b.setAttribute('aria-label', T.voir.replace('{nom}', p.nom));
    b.innerHTML = '<span class="gg-vig-ph"><img src="' + img(p) + '" alt=""></span><span class="gg-vig-nom">' + p.nom + '</span>';
    b.addEventListener('click', () => aller(i));
    $('gg-vignettes').appendChild(b);
  });
  const vigs = [...document.querySelectorAll('.gg-vig')];
  /* puces de pagination (mobile) */
  PILOTES.forEach((p, i) => {
    const b = document.createElement('button');
    b.className = 'gg-puce'; b.setAttribute('aria-label', T.voir.replace('{nom}', p.nom));
    b.addEventListener('click', () => aller(i));
    $('gg-puces').appendChild(b);
  });
  const puces = [...document.querySelectorAll('.gg-puce')];

  /* scrubbing : doigt maintenu sur la capsule de puces et glissé,
     les fiches défilent instantanément sous le doigt */
  function nomInstant(p) {
    const h = $('gg-nom');
    h.setAttribute('aria-label', p.nom); h.textContent = p.nom;
    ajusteNom();
    $('gg-num').textContent = p.num;
  }
  function bascule(i) {
    if (i === idx) return;
    idx = i; stopTout(); verrou = false;
    const p = PILOTES[i];
    nomInstant(p); remplit(p, i);
  }
  (function () {
    const cont = $('gg-puces'); let scrub = false;
    function scrubTo(x) {
      let best = 0, bd = Infinity;
      puces.forEach((b, j) => {
        const r = b.getBoundingClientRect(), d = Math.abs(x - (r.left + r.width / 2));
        if (d < bd) { bd = d; best = j; }
      });
      bascule(best);
    }
    cont.addEventListener('touchstart', (e) => { scrub = true; scrubTo(e.touches[0].clientX); e.preventDefault(); }, { passive: false });
    cont.addEventListener('touchmove', (e) => { if (scrub) { scrubTo(e.touches[0].clientX); e.preventDefault(); } }, { passive: false });
    cont.addEventListener('touchend', () => { scrub = false; });
    cont.addEventListener('touchcancel', () => { scrub = false; });
  })();

  /* ---------- helpers d'animation ---------- */
  function splitNom(txt) {
    const h = $('gg-nom'); h.setAttribute('aria-label', txt); h.textContent = '';
    [...txt].forEach((c) => {
      const s = document.createElement('span'); s.className = 'l'; s.setAttribute('aria-hidden', 'true');
      s.innerHTML = c === ' ' ? '&nbsp;' : c; h.appendChild(s);
    });
    ajusteNom();
    return [...h.children];
  }
  /* un nom long doit tenir sur une seule ligne : on réduit la taille
     jusqu'à ce que ça rentre. Rejoué quand la police display finit de
     charger et au redimensionnement. Garde-fous : mesures à 0 ignorées,
     jamais sous 24px. */
  function ajusteNom() {
    const h = $('gg-nom');
    h.style.fontSize = '';
    const dispo = h.parentElement.clientWidth;
    const fs = parseFloat(getComputedStyle(h).fontSize);
    if (dispo > 0 && fs > 0 && h.scrollWidth > dispo) {
      h.style.fontSize = Math.max(24, Math.floor(fs * dispo / h.scrollWidth * 0.95)) + 'px';
    }
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajusteNom);
  let tRedim;
  window.addEventListener('resize', () => { clearTimeout(tRedim); tRedim = setTimeout(ajusteNom, 150); });
  function poseNum(num) {
    const n = $('gg-num'); n.textContent = '';
    return [...num].map((c) => {
      const slot = document.createElement('span'); slot.className = 'slot';
      const val = document.createElement('span'); val.className = 'val'; val.textContent = c;
      slot.appendChild(val); n.appendChild(slot); return val;
    });
  }
  const anims = [];
  function joue(el, frames, opts) { const a = el.animate(frames, opts); anims.push(a); return a; }
  function stopTout() { anims.forEach((a) => a.cancel()); anims.length = 0; }

  /* ---------- remplit la scène (sans animation) ---------- */
  function remplit(p, i) {
    sec.style.setProperty('--accent', p.accent);
    $('gg-moto-txt').textContent = p.moto;
    $('gg-chips').innerHTML = (p.chips || []).map((c) => '<li><span>' + c + '</span></li>').join('');
    $('gg-bio').textContent = p.bio;
    $('gg-stats').innerHTML = (p.stats || []).map((v, j) =>
      '<li class="gg-stat"><span class="gg-stat-nom">' + STATS_NOMS[j] + '</span>' +
      '<span class="gg-jauge"><i style="--v:' + (v / 100) + '"></i></span>' +
      '<b class="gg-stat-val">' + v + '</b></li>').join('');
    $('gg-prods').innerHTML = (p.produits || []).map((pr) =>
      '<a class="gg-prod" href="' + pr.href + '">' +
      '<span class="gg-prod-ph"><img src="' + (pr.img_url || DATA.assetBase + pr.img) + '" alt="" loading="lazy"></span>' +
      '<span class="gg-prod-nom">' + pr.nom + '</span></a>').join('');
    let liens = '<a href="https://www.instagram.com/' + p.insta + '/" target="_blank" rel="noopener" aria-label="' + T.insta.replace('{nom}', p.nom) + '">' + SVG_INSTA + '</a>';
    if (p.tiktok) liens += '<a href="https://www.tiktok.com/@' + p.tiktok + '" target="_blank" rel="noopener" aria-label="' + T.tiktok.replace('{nom}', p.nom) + '">' + SVG_TIKTOK + '</a>';
    $('gg-liens').innerHTML = liens;
    $('gg-img').src = img(p);
    $('gg-img').style.setProperty('--gg-cadrage', (p.cadrage == null ? 50 : p.cadrage) + '%');
    $('gg-img').alt = T.portrait.replace('{nom}', p.nom);
    vigs.forEach((v, j) => j === i ? v.setAttribute('aria-current', 'true') : v.removeAttribute('aria-current'));
    puces.forEach((b, j) => b.classList.toggle('on', j === i));
    /* garde la vignette active visible quand le roster déborde */
    const cont = $('gg-vignettes'), v = vigs[i];
    cont.scrollTo({
      left: v.offsetLeft - (cont.clientWidth - v.offsetWidth) / 2,
      behavior: rm.matches ? 'auto' : 'smooth'
    });
    $('gg-live').textContent = T.affiche.replace('{nom}', p.nom).replace('{moto}', p.moto);
    if (location.hash !== '#' + p.id) history.replaceState(null, '', '#' + p.id);
  }

  /* ---------- chorégraphie d'entrée ---------- */
  function entree(p, sens) {
    /* purge les fills de la sortie : les conteneurs resteraient sinon
       bloqués à opacity 0 */
    [$('gg-moto'), $('gg-chips'), $('gg-bio'), $('gg-stats'), document.querySelector('.gg-prods')]
      .forEach((el) => el.getAnimations().forEach((a) => a.cancel()));
    const lettres = splitNom(p.nom);
    const chiffres = poseNum(p.num);
    /* nom : machine à sous, lettre par lettre */
    lettres.forEach((l, j) => joue(l,
      [{ transform: 'translateY(125%)' }, { transform: 'translateY(0)' }],
      { duration: 650, delay: 60 + j * 28, easing: EXPO, fill: 'both' }));
    /* numéro géant : les chiffres roulent */
    chiffres.forEach((c, j) => joue(c,
      [{ transform: 'translateY(' + (sens >= 0 ? '' : '-') + '108%)' }, { transform: 'translateY(0)' }],
      { duration: 700, delay: 120 + j * 70, easing: EXPO, fill: 'both' }));
    /* cascade infos */
    [$('gg-moto'), $('gg-bio'), document.querySelector('.gg-prods')].forEach((el, j) =>
      joue(el, [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 520, delay: 140 + j * 70, easing: EXPO, fill: 'both' }));
    [...$('gg-chips').children].forEach((c, j) =>
      joue(c, [{ opacity: 0, transform: 'skewX(-8deg) translateY(16px)' }, { opacity: 1, transform: 'skewX(-8deg) translateY(0)' }],
        { duration: 460, delay: 220 + j * 55, easing: EXPO, fill: 'both' }));
    /* stats : jauges qui se remplissent */
    [...$('gg-stats').querySelectorAll('.gg-jauge i')].forEach((b, j) => {
      const v = (p.stats || [])[j] / 100 || 0;
      joue(b, [{ transform: 'scaleX(0)' }, { transform: 'scaleX(' + v + ')' }],
        { duration: 750, delay: 340 + j * 85, easing: EXPO, fill: 'both' });
    });
    [...$('gg-stats').querySelectorAll('.gg-stat')].forEach((s, j) =>
      joue(s, [{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: 300 + j * 85, easing: 'ease-out', fill: 'both' }));
    /* photo : la fenêtre glisse sur l'image (contre-mouvement) */
    joue($('gg-img'),
      [{ transform: 'scale(1.22) translateX(' + (sens >= 0 ? 8 : -8) + '%)' }, { transform: 'scale(1) translateX(0)' }],
      { duration: 900, delay: 40, easing: EXPO, fill: 'both' });
  }

  /* ---------- sortie éclair ---------- */
  function sortie() {
    const fini = [];
    [...$('gg-nom').children].forEach((l, j) => fini.push(joue(l,
      [{ transform: 'translateY(0)' }, { transform: 'translateY(-125%)' }],
      { duration: 300, delay: j * 14, easing: HARD, fill: 'both' }).finished));
    [...$('gg-num').querySelectorAll('.val')].forEach((c, j) => fini.push(joue(c,
      [{ transform: 'translateY(0)' }, { transform: 'translateY(-108%)' }],
      { duration: 300, delay: j * 40, easing: HARD, fill: 'both' }).finished));
    [$('gg-moto'), $('gg-chips'), $('gg-bio'), $('gg-stats'), document.querySelector('.gg-prods')]
      .forEach((el, j) => fini.push(joue(el,
        [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-12px)' }],
        { duration: 240, delay: j * 28, easing: 'ease-in', fill: 'both' }).finished));
    return Promise.all(fini);
  }

  /* ---------- wipe diagonal de la photo ---------- */
  function wipePhoto(sens) {
    const carte = $('gg-carte');
    const clone = carte.cloneNode(true);
    clone.classList.add('gg-carte-old'); clone.setAttribute('aria-hidden', 'true');
    /* pas d'ids dupliqués dans le DOM le temps du wipe */
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((e) => e.removeAttribute('id'));
    carte.parentNode.appendChild(clone);
    const versGauche = sens >= 0;
    const plein = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
    const ferme = versGauche
      ? 'polygon(0% 0%, 8% 0%, -22% 100%, 0% 100%)'
      : 'polygon(92% 0%, 100% 0%, 100% 100%, 122% 100%)';
    /* le fondu sur les derniers 30 % évite la coupure sèche */
    const a = clone.animate(
      [{ clipPath: plein, opacity: 1 }, { clipPath: plein, opacity: 1, offset: 0.08 },
       { opacity: 1, offset: 0.68 }, { clipPath: ferme, opacity: 0 }],
      { duration: 680, easing: HARD, fill: 'forwards' });
    /* contre-mouvement de l'image dans le clone */
    clone.querySelector('img').animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.18) translateX(' + (versGauche ? -6 : 6) + '%)' }],
      { duration: 620, easing: HARD, fill: 'forwards' });
    a.finished.then(() => clone.remove()).catch(() => clone.remove());
    /* flash d'accent au cœur de la transition */
    $('gg-flash').animate([{ opacity: 0 }, { opacity: 0.22, offset: 0.4 }, { opacity: 0 }],
      { duration: 520, delay: 60, easing: 'ease-in-out' });
  }

  /* ---------- navigation ---------- */
  function aller(i) {
    if (verrou || i === idx || i < 0 || i >= PILOTES.length) return;
    const sens = i > idx ? 1 : -1;
    idx = i; const p = PILOTES[i];
    if (rm.matches) { nomInstant(p); remplit(p, i); return; }
    verrou = true; stopTout();
    sortie().then(() => {
      wipePhoto(sens);
      remplit(p, i);
      entree(p, sens);
      setTimeout(() => { verrou = false; }, 780);
    }).catch(() => { verrou = false; }); /* transition interrompue (scrub) */
  }
  const suivant = () => aller(Math.min(idx + 1, PILOTES.length - 1));
  const precedent = () => aller(Math.max(idx - 1, 0));
  $('gg-next').addEventListener('click', suivant);
  $('gg-prev').addEventListener('click', precedent);
  $('gg-next-m').addEventListener('click', suivant);
  $('gg-prev-m').addEventListener('click', precedent);

  /* clavier */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { suivant(); }
    else if (e.key === 'ArrowLeft') { precedent(); }
  });

  /* molette : un cran = un pilote ; on rend la main au scroll naturel
     au premier pilote (vers le header) et au dernier (vers le footer) */
  sec.addEventListener('wheel', (e) => {
    const bas = e.deltaY > 0;
    if ((bas && idx === PILOTES.length - 1) || (!bas && (idx === 0 || window.scrollY > 10))) return;
    e.preventDefault();
    const t = Date.now();
    if (verrou || t - derniereMolette < 650 || Math.abs(e.deltaY) < 24) return;
    derniereMolette = t;
    bas ? suivant() : precedent();
  }, { passive: false });

  /* swipe tactile */
  let tx = null, ty = null;
  sec.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
  sec.addEventListener('touchend', (e) => {
    if (tx === null) return;
    const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
    tx = ty = null;
    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.4) dx < 0 ? suivant() : precedent();
  }, { passive: true });

  /* parallax curseur : la photo suit légèrement la souris */
  if (!rm.matches && matchMedia('(pointer:fine)').matches) {
    const media = $('gg-media'); let cx = 0, cy = 0, vx = 0, vy = 0;
    media.addEventListener('mousemove', (e) => {
      const r = media.getBoundingClientRect();
      cx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      cy = ((e.clientY - r.top) / r.height - 0.5) * 2;
    });
    media.addEventListener('mouseleave', () => { cx = cy = 0; });
    (function boucle() {
      /* pas de parallax en dessous de 900px : la mise en page mobile
         positionne le numéro sans transform */
      if (innerWidth > 900) {
        vx += (cx - vx) * 0.07; vy += (cy - vy) * 0.07;
        document.querySelector('.gg-cadre').style.transform =
          'translate(' + (vx * 10).toFixed(2) + 'px,' + (vy * 8).toFixed(2) + 'px)';
        $('gg-num').style.transform = 'translateY(-56%) translate(' + (vx * -14).toFixed(2) + 'px,' + (vy * -8).toFixed(2) + 'px)';
      } else {
        document.querySelector('.gg-cadre').style.transform = '';
        $('gg-num').style.transform = '';
      }
      requestAnimationFrame(boucle);
    })();
  }

  /* ---------- démarrage (deep link par hash) ---------- */
  const h = location.hash.replace('#', '');
  idx = Math.max(0, PILOTES.findIndex((p) => p.id === h));
  remplit(PILOTES[idx], idx);
  if (!rm.matches) { verrou = true; entree(PILOTES[idx], 1); setTimeout(() => { verrou = false; }, 900); }
})();
